import { Box, FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import { CustomButton } from "../../../components/customButton/CustomButton";

const MESES = [
    { id: 1, displayName: "Enero" },    { id: 2, displayName: "Febrero" },
    { id: 3, displayName: "Marzo" },    { id: 4, displayName: "Abril" },
    { id: 5, displayName: "Mayo" },     { id: 6, displayName: "Junio" },
    { id: 7, displayName: "Julio" },    { id: 8, displayName: "Agosto" },
    { id: 9, displayName: "Septiembre" }, { id: 10, displayName: "Octubre" },
    { id: 11, displayName: "Noviembre" }, { id: 12, displayName: "Diciembre" },
];

const buildAnioOptions = () => {
    const anioActual = new Date().getFullYear();
    return Array.from({ length: 5 }, (_, i) => ({
        id: anioActual - i,
        displayName: String(anioActual - i),
    }));
};

const filtersAreValid = (filters) =>
    !!filters.mes && !!filters.anio && !!filters.idTipoProfesional && !!filters.idDelegacion;

export const RvMailFilters = ({
    filters,
    handleChangeFilters,
    handleSearch,
    tiposProfesionalOptions,
    delegacionesOptions,
}) => (
    <Grid container spacing={2} sx={{ mb: 3 }}>

        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <FormControl fullWidth size="small" sx={{ backgroundColor: "white" }}>
                <InputLabel>Mes</InputLabel>
                <Select
                    label="Mes"
                    value={filters.mes ?? ""}
                    onChange={(e) => handleChangeFilters("mes", e.target.value)}
                >
                    {MESES?.map((m) => (
                        <MenuItem key={m.id} value={m.id}>{m.displayName}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 2 }}>
            <FormControl fullWidth size="small" sx={{ backgroundColor: "white" }}>
                <InputLabel>Año</InputLabel>
                <Select
                    label="Año"
                    value={filters.anio ?? ""}
                    onChange={(e) => handleChangeFilters("anio", e.target.value)}
                >
                    {buildAnioOptions()?.map((a) => (
                        <MenuItem key={a.id} value={a.id}>{a.displayName}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <FormControl fullWidth size="small" sx={{ backgroundColor: "white" }}>
                <InputLabel>Tipo Profesional</InputLabel>
                <Select
                    label="Tipo Profesional"
                    value={filters.idTipoProfesional ?? ""}
                    onChange={(e) => handleChangeFilters("idTipoProfesional", e.target.value)}
                >
                    {tiposProfesionalOptions?.map((t) => (
                        <MenuItem key={t.id} value={t.id}>{t.displayName}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <FormControl fullWidth size="small" sx={{ backgroundColor: "white" }}>
                <InputLabel>Delegación</InputLabel>
                <Select
                    label="Delegación"
                    value={filters.idDelegacion ?? ""}
                    onChange={(e) => handleChangeFilters("idDelegacion", e.target.value)}
                >
                    {delegacionesOptions?.map((d) => (
                        <MenuItem key={d.id} value={d.id}>{d.displayName}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Grid>

        <Grid size={{ xs: 12, sm: 6, md: 1 }}>
            <CustomButton
                label="Buscar"
                variant="contained"
                fullWidth
                disabled={!filtersAreValid(filters)}
                onClick={handleSearch}
            />
        </Grid>

    </Grid>
);